import React from 'react';
import clsx from 'clsx';
import { Card, CardHeader, CardContent, CardActions, Collapse, Typography, IconButton, Button, Grid } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import '../styles/overviewcard.css';

const rootClass = "overviewcard root";
const expandedClass = "overviewcard expanded";
const expandOpenClass = "overviewcard expandopen";
const buttonClass = "overviewcard button";
const titleClass = "overviewcard title";
const descriptionClass = "overviewcard description";


class OverviewCard extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            expanded: false,
        };
        this.handleExpandClick = this.handleExpandClick.bind(this);
    }

    handleExpandClick() {
        this.setState({
            expanded: !this.state.expanded,
        });
    }

    render() {

        return (
            <>
                <Card className={rootClass}>
                    <CardHeader title={this.props.title} className={titleClass} style={this.props.colort && {background: this.props.colort}}/>
                    <CardContent style={this.props.colord && {background: this.props.colord}}>
                        <Typography variant="body2" className={descriptionClass} >
                            {this.props.description}
                        </Typography>
                    </CardContent>
                    <CardActions disableSpacing style={{cursor: 'pointer', background: (this.props.colora ? this.props.colora : undefined)}} onClick={this.handleExpandClick}>
                        <IconButton
                            className={clsx(expandedClass, {
                                [expandOpenClass]: this.state.expanded,
                            })}
                            onClick={this.handleExpandClick}
                            aria-expanded={this.state.expanded}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </IconButton>
                    </CardActions>
                    <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
                        <CardContent>
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                                spacing={3}
                            >
                                {this.props.buttons.map(element => {
                                    return (
                                        <Grid item xs key={element['name']}>
                                            <Button className={buttonClass} href={element['href']} onClick={element['onClick']} fullWidth>{element['name']}</Button>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </CardContent>
                    </Collapse>
                </Card>
            </>
        );
    }
}

export default OverviewCard;